import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { UtilityService } from '../_services/utility.service';
import { NotificationService } from '@app/_services/_common/notification.service';
import { AUTH_ROUTE_PREFIX } from '@app/enums';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private utility: UtilityService, private notification: NotificationService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          if (event.body?.code === 999 && this.utility.isUserLoggedIn()) {
            // only show error 1 time, so check if user is logged in.
            this.notification.error("Your session has expired. Please login again!")
            this.utility.clearLocalStorage();
            this.router.navigate([`${AUTH_ROUTE_PREFIX}/login`]);
          }
        }
      })
    );
  }
}
